export default "__VITE_ASSET__CWqPJ6gV__"